import { render, staticRenderFns } from "./InputEditor.vue?vue&type=template&id=4480a3a3&scoped=true&"
import script from "./InputEditor.vue?vue&type=script&lang=js&"
export * from "./InputEditor.vue?vue&type=script&lang=js&"
import style0 from "./InputEditor.vue?vue&type=style&index=0&id=4480a3a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480a3a3",
  null
  
)

export default component.exports